import React, {useState, useEffect, useContext}from 'react'
import { FirebaseContext } from '../../Services/firebase'
import TaxationDocument from './taxationDocument';
import CurrencyInput from 'react-currency-input-field';
import BasicTable from './dataTable';
import { PDFViewer } from '@react-pdf/renderer';

import { getCustomerList } from '../../Utils/getCustomerList';

import { TextField, Button, Autocomplete, MenuItem, Select, InputLabel, Dialog, DialogContent } from '@mui/material';

export default function Taxation(props) {

    const firebase = useContext(FirebaseContext)

    const [Customers, setCustomers] = useState([]);
    const [value, setValue] = useState('clients');
    const [inputValue, setInputValue] = React.useState('');
    const [Month, setMonth] = useState("");
    const [Montant, setMontant] = useState('0');
    const [Tiers, setTiers] = useState('0');
    const [IsShowing, setIsShowing] = useState(false);
    const [Table, setTable] = useState();
    const [open, setOpen] = React.useState(false);
    const [Infos, setInfos] = useState([]);
    const [Total, setTotal] = useState();
    const [PeriodeA, setPeriodeA] = useState('');
    const [PeriodeB, setPeriodeB] = useState('');
    const [isPeriod, setisPeriode] = useState(true);

    useEffect(() => {
            getCustomerList(firebase, props.UserSession.uid, setCustomers)
        }, [firebase, props.UserSession.uid])

    const getInfos = () => {
        setInfos([])
        firebase.getCustomerInfos(props.UserSession.uid, value).get()
        .then( doc => {
            const mydata = doc.data()
            setInfos(mydata)
        })
    }

    const handleMonth = (event) => {
        setMonth(event.target.value);
        try {
            firebase.checkTaxationMonth(props.UserSession.uid, value).get()
            .then( doc => {
                if (doc.data()[event.target.value]) {
                    setMontant(doc.data()[event.target.value])
                    alert(`une valeur est déjà renseigné pour le mois de ${event.target.value}, enregistrez une nouvelle valeur afin de la modifier.`)
                } else {
                    setMontant('0')
                } 
            }).catch(error => {
                //alert(error.message)
            })
        }catch(err) {
            //alert(err)
        }
    };

    const handleMontant = (value) => {
        setMontant(value);
    }

    const handleTiers = (value) => {
        setTiers(value);
    }

    const saveAmount = () => {
        firebase.checkTaxationMonth(props.UserSession.uid, value).get()
        .then(doc => {
            if (doc.exists === false) {
                console.log('create')
                firebase.newTaxationMonth(props.UserSession.uid, value, {[Month]: Montant})
                alert(`La taxe pour ${value} au mois de ${Month} a bien été enregistrée`)
                setMontant("")
                setMonth("")
                setIsShowing(false)
            } else {
                console.log('update')
                firebase.updateTaxationMonth(props.UserSession.uid, value, {[Month]: Montant})
                alert(`La taxe pour ${value} au mois de ${Month} a bien été enregistrée`)
                setMontant("")
                setMonth("")
                setIsShowing(false)
            }
        })
    }

    const deleteValues = () => {
        firebase.updateTaxationMonth(props.UserSession.uid, value, {
            "Décembre_N-1": "0",
            "Janvier": "0",
            "Février": "0",
            "Mars": "0",
            "Avril": "0",
            "Mai": "0",
            "Juin": "0",
            "Juillet": "0",
            "Aout": "0",
            "Septembre": "0",
            "Octobre": "0",
            "Novembre": "0",
            "Décembre": "0",
        }).then(doc => {
            alert('Toutes les valeurs ont été supprimées')
        })
    }

    const ShowClientValues = () => {
        firebase.checkTaxationMonth(props.UserSession.uid, value).get()
        .then(doc => {
            if (doc.exists === false) {
                alert("Rien à afficher: aucun montant n'a été renseigné pour ce client.")
            } else {
                console.log(doc.data())
                setTable(doc.data())
                setIsShowing(!IsShowing)
            }
        })
    }

    const generateDocument = () => {
        getInfos();
        firebase.checkTaxationMonth(props.UserSession.uid, value).get()
        .then(doc => {
            setTotal(Object.values(doc.data())
            .map(amount => parseFloat(amount.toString().replace(",", ".")) || 0) 
            .reduce((total, amount) => total + amount, 0));
        })
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    };

    const setPeriodeStart = (event) => {
        setPeriodeA(event.target.value)
    }

    const setPeriodeEnd = (event) => {
        setPeriodeB(event.target.value)
    }

    useEffect(() => {
        if (PeriodeA !== "" && PeriodeB !== "") {
            setisPeriode(false)
        } else {
            setisPeriode(true)
        }

    }, [PeriodeA, PeriodeB]);

    return(
        <div style={{display: 'flex'}}>
            { IsShowing === false || value === "" || value === "clients" ? null : 
                <BasicTable rows={Table}/>
            }
            <div style={{display: "flex", flexDirection: "column"}}>
                <div style={{display: "flex", flexDirection: "row"}}>
                    <div style={{display: "flex", flexDirection: "column"}}>
                        <Autocomplete
                            value={value}
                            onChange={(event, newValue) => {
                                setValue(newValue);
                                setIsShowing(false)
                            }}
                            inputValue={inputValue}
                            onInputChange={(event, newInputValue) => {
                                setInputValue(newInputValue);
                                setIsShowing(false)
                            }}
                            disablePortal
                            id="combo-box-demo"
                            options={Customers}
                            sx={{ width: 300 }}
                            renderInput={(params) => <TextField {...params} label="clients" />}
                        />
                    </div>
                    { value !== 'clients' && value != null && value !== "" ? 
                    <>
                        { IsShowing === false ? 
                            <Button variant="contained" style={{padding: "10px", marginLeft: "10px", height: "40%", alignSelf: "end"}} onClick={ShowClientValues} >Aficher</Button>
                            :
                            <Button variant="contained" style={{padding: "10px", marginLeft: "10px", height: "40%", alignSelf: "end", backgroundColor: "red"}} onClick={ShowClientValues} >Masquer</Button>
                        }
                    </> : null
                    }
                </div>
                { value !== 'clients' && value != null && value !== "" ? 
                    <>
                        <p style={{marginTop: "50px", lineHeight: "5px"}}>Ajouter un montant</p>
                        <div style={{display: "flex", flexDirection: "row", alignItems: "end"}}>
                            <div style={{display: "flex", flexDirection: "column", marginRight: "20px"}}>
                                <InputLabel id="demo-simple-select-label">Mois</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={Month}
                                    label="Mois"
                                    onChange={handleMonth}
                                    sx={{width: "12vw"}}
                                    >
                                    <MenuItem value={'Décembre_N-1'}>Décembre N-1</MenuItem>
                                    <MenuItem value={'Janvier'}>Janvier</MenuItem>
                                    <MenuItem value={'Février'}>Février</MenuItem>
                                    <MenuItem value={'Mars'}>Mars</MenuItem>
                                    <MenuItem value={'Avril'}>Avril</MenuItem>
                                    <MenuItem value={'Mai'}>Mai</MenuItem>
                                    <MenuItem value={'Juin'}>Juin</MenuItem>
                                    <MenuItem value={'Juillet'}>Juillet</MenuItem>
                                    <MenuItem value={'Aout'}>Août</MenuItem>
                                    <MenuItem value={'Septembre'}>Septembre</MenuItem>
                                    <MenuItem value={'Octobre'}>Octobre</MenuItem>
                                    <MenuItem value={'Novembre'}>Novembre</MenuItem>
                                    <MenuItem value={'Décembre'}>Décembre</MenuItem>
                                </Select>
                            </div>
                            <div style={{display: "flex", flexDirection: "column", marginRight: "20px"}}>
                                <InputLabel id="demo-simple-select-label">Montant</InputLabel>
                                <CurrencyInput
                                    suffix="€"
                                    id="input-example"
                                    name="Montant"
                                    placeholder="Entrez le montant"
                                    defaultValue={0}
                                    decimalsLimit={10}
                                    value={Montant}
                                    onValueChange={handleMontant}
                                    style={{height: "50px", paddingLeft: "10px"}}
                                />
                            </div>
                            <Button variant="contained" style={{marginTop: "1vh", padding: "10px"}} onClick={saveAmount} >Enregistrer</Button>
                        </div>
                        <p style={{marginTop: "50px", lineHeight: "5px"}}>Générer l'attestation</p>
                        <div style={{display: "flex", flexDirection: "column", marginRight: "20px"}}>
                        <InputLabel id="demo-simple-select-label">Période</InputLabel>
                            <div style={{display: "flex", flexDirection: "row"}}>
                                <TextField required id="outlined-basic" label="Début" variant="outlined" placeholder='Décembre 202X' onChange={setPeriodeStart}/>
                                <p style={{marginLeft: "10px"}}>à</p>
                                <TextField required id="outlined-basic" label="Fin" variant="outlined" placeholder='Novembre 202X' style={{marginLeft: "10px"}} onChange={setPeriodeEnd}/>
                            </div>
                        </div>
                        <InputLabel id="demo-simple-select-label">Autres prestations</InputLabel>
                        <CurrencyInput
                            suffix="€"
                            id="input-example"
                            name="Tiers"
                            placeholder="Entrez le montant"
                            defaultValue={0}
                            decimalsLimit={2}
                            value={Tiers}
                            onValueChange={handleTiers}
                            style={{height: "50px", paddingLeft: "10px"}}
                        />
                        <Button  disabled={isPeriod} variant="contained" style={{marginTop: "1vh", width: "8vw", padding: "10px"}} onClick={generateDocument} >Générer</Button>
                        <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            fullWidth={true}
                            maxWidth={'lg'}
                        >
                            <DialogContent>
                                <PDFViewer style={{width: "90vw", height: "80vh"}}>
                                    <TaxationDocument total={Total} tiers={Tiers} client={Infos} periodeStart={PeriodeA} periodeEnd={PeriodeB}/>
                                </PDFViewer>
                            </DialogContent>
                        </Dialog>
                        <p style={{marginTop: "50px", lineHeight: "5px"}}>Supprimer les valeurs pour ce client</p>
                        <Button variant="contained" style={{marginTop: "1vh", width: "8vw", padding: "10px", backgroundColor: "red"}} onClick={deleteValues} >Supprimer</Button>
                    </> : null
                }
            </div>
        </div>
    )

}